// @ts-expect-error untyped module reference-resolvers
import { TEAM } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module customer-data-reference-ui-components
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Example:
 *   <TeamName id="123" />
 * Renders as:
 *   My Team Name
 */
const TeamName = ({
  id,
  href,
  messageKey
}) => /*#__PURE__*/_jsx(ReferenceName, {
  id: id,
  referenceObjectType: TEAM
  // NOTE: no default href because HubSpot has no direct url to view a team (just /settings/:portalId/users/teams)
  //       See https://git.hubteam.com/HubSpot/CRM-Issues/issues/2735
  ,
  href: href,
  messageKey: messageKey
});
export default TeamName;